<template>
  <main class="main-content">
    <div class="card">
      <div class="card-body" v-if="staff!=null">
        <div class="card-title">
           <div class="d-flex justify-content-end my-2 my-1 d-print-none">
          <a
          @click="printReport"
          class="btn btn-success m-l-5 my-1">
            <i class="fa fa-print m-r-5"></i> چاپ
          </a>
        </div>
          <div class="d-flex justify-content-center">
             <img src="@/assets/logo2.jpg" alt="">
          </div>
          <hr>
          <div class="d-flex justify-content-between px-2">
            <span class="font-size-15">
              <span>
               گزارش پروژه های کارمند :
              </span>
              <span>
                {{staff.name}}
              </span>
            </span>
            <span class="font-size-15">
              <span>تاریخ: </span>
              <span>{{this.$route.params.date}}</span>
            </span>
          </div>
          <hr>
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th style="width:5%">ردیف</th>
                <th style="width:10%">کد پروژه</th>
                <th style="width:10%">عنوان پروژه</th>
                <th style="width:10%">ساعت</th>
                <th style="width:65%">متن گزارش</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(report , index) in reports" :key="index">
                <td>{{index+1}}</td>
                <td>{{ report.project.code }}</td>
                <td>{{ report.project.name }}</td>
                <td>{{ report.clock }}</td>
                <td v-html="report.body"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr>
        <div class="d-flex">
          <div class="col-3">
            <span class="font-size-13">شرکت طراحی اراک بروج | اراک، خیابان جوادالائمه، نبش کوچه عیوضی</span>
          </div>
          <div class="col-3">
            <span class="font-size-13">تلفن : 32262626-86-98+</span>
          </div>
            <div class="col-3">
            <span class="font-size-13">ایمیل : mghiasfar@gmail.com</span>
          </div>
            <div class="col-3 d-flex justify-content-end">
            <span class="font-size-13">فکس : 32268298-86-98+</span>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'installerReport',
  data () {
    return {
      staff: null,
      reports: null
    }
  },
  beforeCreate () {
    this.$send.submit('get', 'api/staff/report/' + this.$route.params.id + '/' + this.$route.params.date)
      .then(response => {
        this.staff = response.user
        this.reports = response.reports
      })
  },
  methods: {
    printReport () {
      window.print()
    }
  }

}
</script>

<style>

</style>
